import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { DataType, DataTypeUtil } from './data-type';

export type FormElement = FormGroup | FormArray | FormControl

export enum FormElementType {
  FormGroup,
  FormArray,
  FormControl
}

export class FormElementTypeUtil {
  public static getType(data: any): FormElementType {
    switch(DataTypeUtil.getType(data)) {
      case DataType.Object:
        return FormElementType.FormGroup;
      case DataType.Array:
        return FormElementType.FormArray;
      case DataType.Date:
      case DataType.String:
      case DataType.Boolean:
      case DataType.Number:
        return FormElementType.FormControl;
      default:
        return null;
    }
  }
}
